(function($, window, document, undefined) {
  var $win = $(window);
  var $doc = $(document);

  // Accessibility trigger
  $win.on('load', function() {
    setTimeout(function() {
      $('.footer-nav a').each(function() {
        var $this = $(this);

        if ($this.text().toLowerCase().indexOf('accessibility') >= 0) {
          $this.addClass('link-accessibility');
        }
      });

      $('.link-accessibility').on('click', function(event) {
        event.preventDefault();

        $('.acsb-trigger').trigger('click');
      });
    }, 1000);
  });

  var newsletterFlag = false;

  $doc.ready(function(){
    $('.newsletter-form').on('submit', function(e){
      var $this = $(this);
      var email = $this.find('[name="contact[email]"]').val();
      var listID = $this.data('id');
      if (!newsletterFlag && email.length) {
        e.preventDefault();

        $.ajax({
          url: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
          type: 'POST',
          data: `g=${listID}&email=${email}`
        }).always(() => {
          newsletterFlag = true;
          $this.trigger('submit');
        });
      }
    })
  })

})(jQuery, window, document);
